import NAV_PATHS from '@lib/const/nav-paths.const'

export const isExternalHref = (url: string) =>
  /^https?:\/\//i.test(url?.trim() || '')

export const normalizeFeaturedButtonUrl = (
  url: string,
  locale: string
): string => {
  if (!url) return ''

  const trimmed = url.trim()

  if (isExternalHref(trimmed)) {
    return trimmed
  }

  const pathWithoutEnPrefix = trimmed.replace(/^\/en(?=\/)/, '')

  if (
    pathWithoutEnPrefix === '/shop' ||
    pathWithoutEnPrefix.startsWith('/shop/')
  ) {
    return NAV_PATHS.giftShop[locale as 'tr' | 'en'] ?? NAV_PATHS.giftShop.tr
  }

  return trimmed
}
